<dc-automate-social-heading></dc-automate-social-heading>

<dc-slider-card-projects></dc-slider-card-projects>
<dc-automate-social-get-started></dc-automate-social-get-started>
<dc-automate-social-why></dc-automate-social-why>
<dc-automate-social-automation-solution></dc-automate-social-automation-solution>
<dc-counter2></dc-counter2>
<dc-counter3></dc-counter3>
<dc-trust-us [title]="'Part of our happy customers'"></dc-trust-us>
<dc-testimonial-simple-slider-boxed></dc-testimonial-simple-slider-boxed>
<dc-cta1 [background]="'contrast'" [edge]="'top-left'"></dc-cta1>

<dc-footer1></dc-footer1>
